var canvasAction={
FIXTURE_SELECTED:'didSelectFixture',
POSITION_SELECTED:'didSelectPosition',
AREA_SELECTED:'didSelectArea'};







var areaSelected=function areaSelected(areaId){return{
targetFunc:canvasAction.AREA_SELECTED,
data:areaId};};


var fixtureSelected=function fixtureSelected(fixtureId){return{
targetFunc:canvasAction.FIXTURE_SELECTED,
data:fixtureId};};


var positionSelected=function positionSelected(positionId){return{
targetFunc:canvasAction.POSITION_SELECTED,
data:positionId};};


module.exports={
actions:canvasAction,
areaSelected:areaSelected,
fixtureSelected:fixtureSelected,
positionSelected:positionSelected};